import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SearchDialog({ isDialogOpened, handleCloseDialog }) {
  const pages = [
    { label: 'Web Development', year: 1994 },
    { label: 'Database Migration', year: 1972 },
    { label: 'BI Analytics', year: 1974 }
  ]
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    handleCloseDialog(false);
  };

  const onOptionSelect = (e) => {
    console.log(e)
  }

  return (
    <div>
      <Dialog
        open={isDialogOpened}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle component={"h1"}>{"Search"}</DialogTitle>
        <DialogContent component={"div"}>
          <DialogContentText
            component={"div"}
            id="alert-dialog-slide-description"
          >
            <TextField
              component={"div"}
              className="w-full sm:w-[35rem]"
              variant="outlined"
              label="Search"
            ></TextField>
            {/* <Autocomplete
             component={"div"}
              className="w-full sm:w-[35rem]"
              id="combo-box-demo"
              options={pages}
              onChange={e => onOptionSelect(e)}
              renderInput={(params) => <TextField {...params} label="Search" />}
            /> */}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
